// extracted by mini-css-extract-plugin
export default {"slider":"peopleSlider_slider__7OwGK","leftArrow":"peopleSlider_leftArrow__E8TR-","rightArrow":"peopleSlider_rightArrow__BPN-o"};